import React, { FunctionComponent } from "react";
import { Link, Image, RichText } from "@sitecore-jss/sitecore-jss-react";
import { SpecialOffersSlideModel } from "./fields.model";
import { LinkField } from "../../types/types";

const CarouselSlide: FunctionComponent<{ model: SpecialOffersSlideModel, isEE: boolean }> = ({ model, isEE }) => {
  return (
    <>
      <div className={(model.badgeLink?.value?.text || model.badgeLink?.value?.href) && "card-label"}>
        <Link field={model.badgeLink as LinkField} />
      </div>
      <div className={`special-offers-card special-offers-card--${model.type?.value  === "offerCardWide"? "large" : "small" }`}>
        <pfe-card pfe-color="lightest" class="card-with-header-image slide-card slide-card--regular">
          <Image
            loading="lazy"
            slot="pfe-card--header"
            pfe-overflow="top right left"
            className="slide-card__image"
            field={model.image}
          />
          <RichText tag="div" slot="pfe-card--header" field={model.title} className="slide-card__text slide-card__text--title" />
          <RichText tag="div" field={model.subtitle} className="slide-card__text" />
          { model.type?.value === "offerCardWide" && (isEE || (model.buttonPrimary?.value?.text || model.buttonPrimary?.value?.href)) && (
            <pfe-cta slot="pfe-card--footer" pfe-priority="secondary">
              <Link field={model.buttonPrimary as LinkField} />
            </pfe-cta>
          )}
          {
            (isEE || (model.buttonSecondary?.value?.text || model.buttonSecondary?.value?.href))
              && <pfe-cta slot="pfe-card--footer" pfe-priority="primary">
                  <Link field={model.buttonSecondary as LinkField} />
                </pfe-cta>
          }
        </pfe-card>
      </div>
    </>
  );
};

export default CarouselSlide;
